<template>
  <li class="login-sns-each kakao">
    <a href="#" @click.prevent="loginKakao">
      <span class="icon-sns icon-kakao"></span>
      <span class="a11y-hidden">카카오로 로그인</span>
    </a>
  </li>
</template>

<script>
/* eslint-disable */
import { loginProc } from '@/common/utils/login'
import { getPromotionCodeFromUrl, loginRedirectUrl, setLibFile } from '@/common/utils/common'
import { SNS_TYPE_KAKAO, SOCIAL_LOGIN_SUCCESS_EVENT } from '@/common/resources/const'

export default {
  data () {
    return {
      signupResultCode: '302'
    };
  },
  methods: {
    login(token) {
      loginProc({userType: SNS_TYPE_KAKAO, userId: token, userPassword: '', saveId: '', autoLogin: ''}).then((data) => {
        this.$events.$emit(SOCIAL_LOGIN_SUCCESS_EVENT, data.needselectprofile);
      }).catch((error) => {
        if (error.response.status === 551 && error.response.data.resultcode === this.signupResultCode){
          window.location.href = loginRedirectUrl(error.response.data.resultoptional, getPromotionCodeFromUrl(location.href))
        } else {
          console.log(error);
        }
      });
    },
    loginKakao() {
      const loginFn = this.login
      Kakao.Auth.login({
        success: function() {
          loginFn(Kakao.Auth.getAccessToken());
        },
        fail: function(err) {
          console.log(err);
        }
      });
    }
  },
  created() {
    if(Kakao && !Kakao.isInitialized())  {
      Kakao.init('30fc7e17b5c56a0ca1e861643292c203');
    }
  }
};
</script>
